import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-sign-in",
  "use": "icon-si-glyph-sign-in-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol viewBox=\"0 0 16 17\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-sign-in\" id=\"icon-si-glyph-sign-in\"><title>912</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1.000000, 1.000000)\" fill=\"#434343\"><path d=\"M10.959,3.917 L10.959,0 L0.096,0 L8,2.666 L8,14.917 L0.219,13 L0.00399999996,13.829 L8.959,16 L8.959,12.915 L10.959,12.915 L10.959,10.042 L8.094,7.042 L10.959,3.917 Z\" class=\"si-glyph-fill\" /><path d=\"M10.0999756,7.102 L12.9699756,10.033 L12.9699755,7.96765129 L15.0159755,7.96765129 L15.0159755,5.9796143 L12.9699755,5.9796143 L12.9699756,4.068 L10.0999756,7.102 Z\" class=\"si-glyph-fill\" /></g><rect fill=\"#434343\" x=\"7\" y=\"9\" width=\"0.958\" height=\"0.916\" class=\"si-glyph-fill\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-sign-in.svg
// module id = FBWj
// module chunks = 62